import { render } from "./App.vue?vue&type=template&id=4c3cf5ba"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=4c3cf5ba&lang=scss"

import exportComponent from "D:\\dev_program\\web\\haorun-changliuxiang\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__